//Function to remove accents
const removeAccents = (str) => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
};

export const searchEngine = (data, target) => {
  target = removeAccents(target.toLowerCase());

  const matches = [];

  for (let order of data) {
    for (let value of Object.values(order)) {
      if (typeof value === "object") {
        for (let element of Object.values(value)) {
          if (typeof element === "object") {
            element = JSON.stringify(element);
          }

          const normalizedElement = removeAccents(
            String(element).toLowerCase()
          );

          if (normalizedElement.includes(target)) {
            matches.push(order);
            break;
          }
        }
      } else {
        const normalizedValue = removeAccents(String(value).toLowerCase());
        if (normalizedValue.includes(target)) {
          matches.push(order);
          break;
        }
      }
    }
  }

  return matches;
};
